import { Badge } from '@wartek-id/badge'
import { Button } from '@wartek-id/button-v1'

import type { KinerjaRealisasiState } from 'types/kinerja'

export const getBadgeByState = (state: KinerjaRealisasiState) => {
  switch (state) {
    case 'PENDING_SUBMISSION':
      return <Badge variant="critical">Belum dikumpulkan</Badge>
    case 'WAITING_EVALUATION':
      return <Badge>Belum dinilai</Badge>
    case 'EVALUATED':
      return <Badge variant="success">Sudah dinilai</Badge>
    case 'DRAFT':
      return <Badge variant="warning">Lanjutkan draf</Badge>
  }
}

export const getBadgeByStateV2 = (state: KinerjaRealisasiState) => {
  switch (state) {
    case 'PENDING_SUBMISSION':
      return <Badge variant="critical">Belum dikumpulkan</Badge>
    case 'WAITING_EVALUATION':
      return <Badge variant="success">Sudah dikumpulkan</Badge>
    case 'EVALUATED':
      return <Badge variant="success">Sudah dikumpulkan</Badge>
    case 'DRAFT':
      return <Badge variant="warning">Lanjutkan draf</Badge>
  }
}

export const getCtaByState = (
  state: KinerjaRealisasiState,
  isViewOnly?: boolean
) => {
  const resolvedState = isViewOnly ? 'EVALUATED' : state

  switch (resolvedState) {
    case 'PENDING_SUBMISSION':
      return (
        <Button size="sm" color="black">
          Kumpulkan
        </Button>
      )
    case 'WAITING_EVALUATION':
      return (
        <Button size="sm" color="white">
          Cek
        </Button>
      )
    case 'EVALUATED':
      return (
        <Button size="sm" color="white">
          Cek
        </Button>
      )
    case 'DRAFT':
      return (
        <Button size="sm" color="black">
          Lanjutkan
        </Button>
      )
  }
}
